import { useEffect, useState } from 'react';
import { v4 as uuid } from 'uuid';
import DragIndicatorOutlinedIcon from '@mui/icons-material/DragIndicatorOutlined';
import { useFirestoreOrderBy } from '../../firebase/useFirestore';
import { db, timestamp } from '../../firebase/config';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined'
import { client } from '../../hooks/Client'
import Table from '../../components/common/table/Table.jsx';
import TableCell from '../../components/common/table/TableCell.jsx';
import TableDragHandleCell from '../../components/common/table/TableDragHandleCell.jsx';

const MyFinanciers = () => {
    // State
    const [dragArray, setDragArray] = useState([]);

    // Firestore
    const financiers = useFirestoreOrderBy('Financiers', 'Position', 'asc')

    // Type array
    const typeArray = ['Fonds', 'Gemeente', 'Investeerder', 'Klant', 'Inkoper', 'Donateur', 'Maatschappelijk aandeelhouder', 'Anders']

    useEffect(() => {
        setDragArray((prev) => {
            const next = financiers || [];
            if (Array.isArray(prev) && prev.length === next.length) {
                const same = prev.every((p, i) => {
                    const n = next[i];
                    return p.docid === n.docid && p.Position === n.Position && p.Title === n.Title && p.Type === n.Type;
                });
                if (same) return prev;
            }
            return next;
        });
    }, [financiers]);

    const handleDragEnd = (result) => {
        if (!result.destination) return;

        const items = Array.from(dragArray);
        const [moved] = items.splice(result.source.index, 1);
        items.splice(result.destination.index, 0, moved);

        setDragArray(items);

        items.forEach((item, idx) => {
            db.collection('Financiers').doc(item.docid).update({ Position: idx + 1 });
        });
    };

    const deleteFinancier = (e) => {
        const docid = e.currentTarget.dataset.docid
        db.collection('Financiers').doc(docid).delete()
    }

    const addFinancier = () => {
        db.collection('Financiers').add({
            Title: 'Nieuwe financier',
            Type: '',
            ID: uuid(),
            Compagny: client,
            CompagnyID: client,
            Position: (financiers?.length || 0) + 1,
            Timestamp: timestamp
        })
    }

    const titleHandler = (e) => {
        const docid = e.target.dataset.docid
        const value = e.target.value
        db.collection('Financiers').doc(docid).update({ Title: value })
    }

    const typeHandler = (e) => {
        const docid = e.target.dataset.docid
        const value = e.target.options[e.target.selectedIndex].value
        db.collection('Financiers').doc(docid).update({ Type: value })
    }

    return (
        <div className="main">
            <div className="main-container">
                <div className="page-header">
                    <h1>Mijn financiers</h1>
                </div>
                <Table
                    columns={[
                        { key: 'drag', label: '', searchable: false },
                        { key: 'name', label: 'NAAM' },
                        { key: 'type', label: 'TYPE', searchable: false },
                        { key: 'delete', label: 'VERWIJDEREN', searchable: false },
                    ]}
                    items={dragArray || []}
                    draggable
                    droppableId="financiers"
                    onDragEnd={handleDragEnd}
                    getItemKey={(item) => item.ID || item.docid}
                    emptyMessage="Nog geen financiers gevonden."
                    searchAccessor={(item) => item?.Title || ''}
                    searchPlaceholder="Zoeken op naam"
                    addRow={{
                        toolTipContent: 'Financier toevoegen',
                        onClick: addFinancier,
                    }}
                    renderRow={(item) => (
                        <>
                            <TableDragHandleCell>
                                <DragIndicatorOutlinedIcon />
                            </TableDragHandleCell>
                            <TableCell>
                                <input
                                    type="text"
                                    defaultValue={item.Title}
                                    placeholder="Naam van financier"
                                    data-docid={item.docid}
                                    onChange={titleHandler}
                                />
                            </TableCell>
                            <TableCell>
                                <select value={item.Type} data-docid={item.docid} onChange={typeHandler}>
                                    <option value="">-- Selecteer type --</option>
                                    {typeArray.map((type, index) => (
                                        <option key={index} value={type}>{type}</option>
                                    ))}
                                </select>
                            </TableCell>
                            <TableCell>
                                <DeleteOutlinedIcon className='table-delete-icon' data-docid={item.docid} onClick={deleteFinancier} />
                            </TableCell>
                        </>
                    )}
                />
            </div>
        </div>
    )
}

export default MyFinanciers
